module.exports = __webpack_public_path__ + "static/portrait-1-2bbd7c423bacdfb71b21f4cce4a65469.jpg";